import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const articleImages: Record<string, string> = {
  'article-role-1': 'https://readdy.ai/api/search-image?query=Elegant%20woman%20gazing%20thoughtfully%20at%20her%20wedding%20ring%2C%20soft%20window%20light%2C%20cream%20blouse%2C%20warm%20minimalist%20interior%2C%20delicate%20jewelry%2C%20feminine%20portrait%20photography%2C%20gentle%20expression%2C%20pastel%20tones&width=800&height=500&seq=feat-article-1&orientation=landscape',
  'article-couple-1': 'https://readdy.ai/api/search-image?query=Couple%20having%20an%20intimate%20conversation%20on%20a%20balcony%20at%20sunset%2C%20warm%20golden%20light%2C%20holding%20hands%2C%20cream%20and%20warm%20coral%20tones%2C%20romantic%20atmosphere%2C%20artistic%20photography%2C%20emotional%20connection&width=800&height=500&seq=feat-article-2&orientation=landscape',
  'article-marriage-1': 'https://readdy.ai/api/search-image?query=Two%20intertwined%20hands%20with%20wedding%20bands%2C%20soft%20silk%20fabric%20background%2C%20delicate%20flowers%20nearby%2C%20warm%20golden%20hour%20light%2C%20cream%20and%20rose%20gold%20tones%2C%20elegant%20still%20life%20photography%2C%20romantic%20minimalist&width=800&height=500&seq=feat-article-3&orientation=landscape',
  'article-self-1': 'https://readdy.ai/api/search-image?query=Confident%20woman%20journaling%20in%20a%20cozy%20cafe%20corner%2C%20warm%20ambient%20light%2C%20notebook%20and%20coffee%2C%20cream%20and%20warm%20brown%20tones%2C%20lifestyle%20photography%2C%20serene%20and%20focused%20expression%2C%20artistic%20composition&width=800&height=500&seq=feat-article-4&orientation=landscape',
};

export default function FeaturedArticles() {
  const featured = articles.filter((a) => a.featured).slice(0, 4);

  return (
    <section className="py-14 md:py-20 bg-background-100" data-product-shop>
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-3 mb-10 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
              精选推荐
            </h2>
            <p className="text-foreground-600 text-sm md:text-base">
              编辑精心挑选的优质内容，助你快速上手婚姻生活
            </p>
          </div>
          <Link
            to="/category/newlywed-guide"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors flex items-center gap-1 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featured.map((article, index) => (
            <article key={article.id} className="group cursor-pointer">
              <Link to={`/article/${article.slug}`} className="block">
                <div className="relative rounded-xl overflow-hidden aspect-[8/5] mb-4">
                  <img
                    src={articleImages[article.imageSeq]}
                    alt={article.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 text-xs rounded-full bg-white/85 backdrop-blur-sm text-foreground-700 font-medium">
                      {article.category}
                    </span>
                  </div>
                </div>
                <h3 className="text-base md:text-lg font-heading font-medium text-foreground-900 mb-2 leading-snug group-hover:text-primary-500 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i> {article.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i> {article.readTime}
                  </span>
                </div>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}